import { Link } from 'react-router-dom';
import { UserX, KeyRound, Wrench, PauseCircle } from 'lucide-react';
import { useAuthStore } from '../../lib/auth';

const ITEMS = [
  { key: 'unassigned', label: 'Boştaki araç', hint: 'şoför atanmamış', icon: UserX, tone: 'text-slate-600 bg-slate-100' },
  { key: 'rental', label: 'Kiralık araç', hint: 'dönüş tarihli', icon: KeyRound, tone: 'text-sky-700 bg-sky-100' },
  { key: 'maintenance', label: 'Bakımdaki araç', hint: 'atanamaz', icon: Wrench, tone: 'text-violet-700 bg-violet-100' },
  { key: 'suspended', label: 'Askıdaki araç', hint: 'planlamaya çıkmaz', icon: PauseCircle, tone: 'text-rose-700 bg-rose-100' },
];
const CARD = 'flex items-center gap-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-3';

export function FleetStatusCards({ summary }) {
  const { user } = useAuthStore();
  const canOpen = user?.role === 'SUPER_ADMIN' || (user?.permissions?.allowed_pages || []).includes('vehicle-overview');
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="fleet-status-cards">
      {ITEMS.map(({ key, label, hint, icon: Icon, tone }) => {
        const body = (
          <>
            <span className={`rounded-lg p-2 ${tone}`}><Icon className="h-5 w-5" /></span>
            <span>
              <span className="block text-xs text-slate-500">{label}</span>
              <span className="block text-xl font-bold text-slate-900 dark:text-white leading-tight">{summary?.[key] ?? 0}</span>
              <span className="block text-[10px] text-slate-400">{hint}</span>
            </span>
          </>
        );
        return canOpen
          ? <Link key={key} to="/dashboard/vehicle-overview" className={`${CARD} hover:border-slate-400 transition-colors`} data-testid={`fleet-status-${key}`}>{body}</Link>
          : <div key={key} className={CARD} data-testid={`fleet-status-${key}`}>{body}</div>;
      })}
    </div>
  );
}
